import React from 'react';
import Messenger from './common/Messenger';

function CTA() {
  return (
    <div>
      <section id="cta" class="cta">
        <div class="container" data-aos="zoom-in">
          <div class="row">
            <div class="col-lg-9 text-center text-lg-start">
              <h3>WhatsApp Support</h3>
              <p>
                Need assistance? Our WhatsApp support is available 24/7 to
                assist you every step of the way!
              </p>
            </div>
            <div class="col-lg-3 cta-btn-container text-center">
              <a
                class="cta-btn align-middle"
                target="new"
                href="https://wa.me/919860811038"
              >
                <i class="bi bi-whatsapp"></i> Message on WhatsApp
              </a>
              <Messenger />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CTA;
